module.exports = __webpack_public_path__ + "static/img/be.27d8ca49.svg";